import "./image_carousel_component.module.scss"; import "./image_carousel_component.module.scss.json"; import "./image_component.module.scss"; import "./image_component.module.scss.json"; import "./index.js"
